<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      title="Provision services"
      :large="false"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <fade-transition group>
        <dean-select-form-row id="pbxGroupAdminEmail" label="admin email" placeholder="kies een email"
                              key="pbxGroupAdminEmail"
                              :value="data.pbxGroupAdminEmail"
                              :options="contactsEmail"
                              @input="valueChanged($event, 'contactEmail')"
                              :requiredField="true" :warning="$v.data.pbxGroupAdminEmail.$error"></dean-select-form-row>

        <dean-form-row id="pbxGroupPhoneNumber" label="telefoonnummer" type="string" v-model="data.pbxGroupPhoneNumber"
                       key="pbxGroupPhoneNumber"
                       :requiredField="true" :warning="$v.data.pbxGroupPhoneNumber.$error"></dean-form-row>
      </fade-transition>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import axios from 'axios';
import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotification, validationMessage} from '@/mixins/validations';
import {FadeTransition} from 'vue2-transitions';
import {getErrorCodeFromResponse, getErrorMessageFromResponse, getErrorMessageFromTranslationByErrorCode} from "@/mixins/errorMessage";

@Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
    mixins: [validationMixin],
  })

  export default class ProvisionServicesDialog extends Vue {
    @Validations()
    get validations() {
      const valData: any = {
        data: {
          pbxGroupPhoneNumber: {required},
          pbxGroupAdminEmail: {required},
        },
      };

      return valData;
    }

  public contactsEmail: Array<{ label: string, value: string }> = [];

    // DATA
    @Prop() public payloadData!: {
      [key: string]: {
        [key: string]: string,
      };
    };

    public data: {[key: string]: any} = {
      pbxGroupPhoneNumber: null,
      pbxGroupAdminEmail: null,
    };

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public valueChanged(field: any, id: any) {
      this.data.pbxGroupAdminEmail = field.label;
    }

    public save() {
      // @ts-ignore-next-line
      this.$v.data.$touch();

      if (!this.$v.$invalid) {
        this.$emit('setLoad', true);
        axios.post('/-/trade/api/provisioning.provision.services', {
          customerId: this.payloadData.customerId,
          orderId: this.payloadData.orderId,
          partitionId: this.payloadData.partitionId,
          pbxGroupPhoneNumber: this.data.pbxGroupPhoneNumber,
          pbxGroupAdminEmail: this.data.pbxGroupAdminEmail,
        }).then(
          (response: any) => {
            deanDialogBus.$emit('saved');
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
            this.close();
          },
          (error: any) => {
            const errorResponse = error.response.data;
            const errorCode: string|null = getErrorCodeFromResponse(errorResponse);
            let errorMessage: string|null|any = null;

            if (errorCode) {
              errorMessage = getErrorMessageFromTranslationByErrorCode(errorCode);
            }

            if (null === errorMessage) {
              errorMessage = getErrorMessageFromResponse(errorResponse, this.$store.state.main.notification.messages.couldNotSendData.text);
            }

            if (errorMessage) {
              this.$toast(validationMessage(errorMessage));
            } else {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            }
          },
        ).finally(() => {
          this.$emit('setLoad', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    private async loadPartnerContactList()
    {
      try {
        const customerPartnerListEndpoint = '/-/trade/api/customer.partner.list';

        const customerPartnerListResponse = await axios.post(customerPartnerListEndpoint, {
          id: this.payloadData.customerId
        });

        let partnerId = null;

        if (customerPartnerListResponse.data[0] !== undefined) {
          partnerId = customerPartnerListResponse.data[0].value;
        }

        if (partnerId) {
          const partnerContactListEndpoint = '/-/trade/api/person.contact.list';

          const partnerContactListResponse = await axios.post(partnerContactListEndpoint, {
            id: partnerId,
            filter: {
              contactReceivesNotification: true
            },
          });

          const contacts = partnerContactListResponse.data.data;

          if (contacts !== undefined) {
            for (const contact of contacts) {
              this.contactsEmail.push({
                value: contact.id,
                label: contact.emailAddress,
              });
            }
          }
        }
      } catch (err) {
        this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
      }
    }

    public created() {
      this.$emit('setLoad', false);

      this.loadPartnerContactList();
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

:deep(.dialog .dean-dialog-container) {
  width: 500px;
}

</style>
